import _ from 'lodash';
const language = require('../../reducers/language').default;
const Emitter = require('../../services/emitter').default;
let messages = {};
(() => {
    const getMessage = () => {
        if (window['mstore']) {
            return window['mstore'].getState().intlr.messages;
        }
        return language.intlInitialState.messages;
    };
    const setMessage = () => {
        setTimeout(() => {
            messages = getMessage();
        }, 0);
    };
    if (_.isEmpty(messages)) {
        messages = getMessage();
    }
    Emitter.on('SwitchLanguage', setMessage);
})();
const formatMessage = (data) => {
    // TODO: 固件版本号目前的翻译处理方案，是由 mscratch 提供的方法来解析字段，后期待更换。
    if (_.isString(data)) {
        if (_.has(messages, data)) {
            if (data.indexOf('.') === -1) {
                return _.get(messages, data);
            }
            return messages[data];
        }
        else {
            return window['Mscratch'].instance.formatMessageId(data);
        }
    }
    else {
        if (_.has(messages, data.id)) {
            if (data.id.indexOf('.') === -1) {
                return _.get(messages, data.id);
            }
            return messages[data.id];
        }
        else {
            return window['Mscratch'].instance.formatMessageId(data.id);
        }
    }
};
export default formatMessage;
